export default __webpack_public_path__ + "static/media/editeurs-01@2x.642af830.jpg";